export const SUPPORT_PHONE_NUMBER = '+1 (602) 362-9714';
export const SUPPORT_URL = 'https://support.trackman.com/';
export const SUPPORT_EMAIL = 'support@trackman.com';
